export function loadStyling(editor)
{
	const cssComposer = editor.CssComposer;

	const allRule = `
	* {
		font-family: 'Roboto', 'Arial', sans-serif;
	}
	`;

	const scrollbarRule = `
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}
	
	::-webkit-scrollbar-track {
		background-color: #333333;
	}
	
	::-webkit-scrollbar-corner {
		background-color: #333333;
	}
	
	::-webkit-scrollbar-thumb {
		background-color: #BFBFBF;
	}
	
	::-webkit-scrollbar-thumb:hover {
		background-color: #EBEBEB;
	}
	`;

	const bodyRule = `
	body {
		width: 100vw;
		height: 100vh;
		background: transparent;
	}
	`;

	const wrapperRule = `
	div[data-gjs-type="wrapper"] {
		height: 100vh;
		width: 100vw;
	}
	`;

	cssComposer.addRules([
		allRule,
		scrollbarRule,
		bodyRule,
		wrapperRule,
	].join(' '));
}